export class ActionButtonsConfig {
  static viewAction: any = {
    actionName: 'View',
    key: 'view',
    icon: 'icon icon-view',
  };

  static editAction: any = {
    actionName: 'Edit',
    key: 'edit',
    icon: 'icon icon-edit',
  };

  static deleteAction: any = {
    actionName: 'Delete',
    key: 'delete',
    icon: 'icon icon-trash',
  };

  static appAssignAction: any = {
    actionName: 'App Assign',
    key: 'appAssign',
    icon: 'icon icon-assign-apps',
  };
  static roleAssignAction: any = {
    actionName: 'Role Assign',
    key: 'roleAssign',
    icon: 'icon icon-user-setting',
  };
  static orgAssignAction: any = {
    actionName: 'Organization Assign',
    key: 'orgAssign',
    icon: 'icon icon-organisation',
  };

  static resetPasswordLinkAction: any = {
    actionName: 'Password Reset Link ',
    key: 'resetpassword',
    icon: 'icon icon-share-solid',
  };

  public static APP_ACTIONS = [{ ...ActionButtonsConfig.editAction }];

  public static USERS_ACTIONS = [
    { ...ActionButtonsConfig.appAssignAction },
    { ...ActionButtonsConfig.roleAssignAction },
    { ...ActionButtonsConfig.deleteAction },
    { ...ActionButtonsConfig.orgAssignAction },
  ];
  public static USERS_PWD_ACTIONS = [
    { ...ActionButtonsConfig.appAssignAction },
    { ...ActionButtonsConfig.roleAssignAction },
    { ...ActionButtonsConfig.deleteAction },
    { ...ActionButtonsConfig.orgAssignAction },
    { ...ActionButtonsConfig.resetPasswordLinkAction },
  ];

  public static ORG_ACTIONS = [
    { ...ActionButtonsConfig.editAction },
    { ...ActionButtonsConfig.deleteAction },
    { ...ActionButtonsConfig.viewAction },
  ];
  public static EXPORT_USERS_FIELDS = [
    { name: 'user_id' },
    { name: 'given_name' },
    { name: 'name' },
    { name: 'family_name' },
    { name: 'nickname' },
    { name: 'email' },
    { name: 'created_at' },
    { name: 'updated_at' },
    { name: 'last_login' },
    { name: 'logins_count' },
    { name: 'last_login' },
    { name: 'email_verified' },
    { name: 'identities[0].connection', export_as: 'provider' },
  ];
}
